import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { FileLogger } from "@comunicare/comunicare-helper";
import { IDataSourceBackendParam, IQuestionnaireListInfo } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { QuestionnaireApiService } from "src/app/providers/api/questionnaires-api.service";
import { UserService } from "src/app/providers/user.service";

export class QuestionnairesDataSource extends MatTableDataSourceBackendExtended<IQuestionnaireListInfo> {
  constructor(private questionnairesApiService: QuestionnaireApiService, private userService: UserService) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<IQuestionnaireListInfo[]> {
    if (!this.userService.isAuthorizedSync(null, "dashboard/userQuestionnairesListInfos", "GET")) {
      FileLogger.error("questionnaires.datasource.ts", "Not Authorized to load questionnaires");
      return of([]);
    }
    return this.questionnairesApiService.findQuestionnaires(params) as Observable<IQuestionnaireListInfo[]>;
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
    Use this, the day we decide to make the page implements AbstractBackendTablePage
    return this.questionnairesService
      .getQuestionnairesCount(param.search, param.filters, param.services).pipe(map((response) => response.count));
    */
    return of(0);
  }
}
